import {
  ButtonGroup,
  Input,
  Textarea,
} from "@transfr-inc/dashboard-components/forms";

import {
  CLASS_TIME_PER_WEEK_OPTIONS,
  CRITERIA_FREE_TEXT_MAX,
  INDUSTRY_AREA_OPTIONS,
  INTENT_OPTIONS,
  MATCH_FLEXIBILITY_OPTIONS,
  ROLE_OPTIONS,
} from "../ai-curriculum.constants";

import { DropdownField, readValue } from "./ai-form-field";

export const QuickStartFields = ({ criteria, errors, onChange }) => {
  const isOther = criteria.industryArea?.id === "other";

  const segmentedButtons = (options, field) =>
    options.map((o) => ({
      label: o.name,
      id: o.id,
      onClick: () => onChange({ [field]: o }),
    }));

  return (
    <div className="ai-form-step__fields">
      <DropdownField
        label="What is your role?"
        placeholder="Select a role"
        options={ROLE_OPTIONS}
        selected={criteria.role}
        required
        error={errors.role}
        onChange={(role) => onChange({ role })}
      />
      <DropdownField
        label="Learner Goals?"
        placeholder="Select an intent"
        options={INTENT_OPTIONS}
        selected={criteria.intent}
        required
        error={errors.intent}
        onChange={(intent) => onChange({ intent })}
      />
      <DropdownField
        label="Frequency"
        placeholder="Select an amount of time"
        options={CLASS_TIME_PER_WEEK_OPTIONS}
        selected={criteria.classTimePerWeek}
        required
        error={errors.classTimePerWeek}
        onChange={(classTimePerWeek) => onChange({ classTimePerWeek })}
      />
      <DropdownField
        label="Industry"
        placeholder="Select an industry area"
        options={INDUSTRY_AREA_OPTIONS}
        selected={criteria.industryArea}
        required
        error={errors.industryArea}
        onChange={(industryArea) => onChange({ industryArea })}
      />
      <label className="ai-form-step__field">
        <span className="ai-form-step__label">
          Career
          {isOther && <span className="required">*</span>}
        </span>
        <Input
          placeholder="e.g. Aviation maintenance, Veterinary assisting"
          maxLength={CRITERIA_FREE_TEXT_MAX}
          value={criteria.industrySpecifics}
          errors={errors.industrySpecifics}
          onChange={(e) => onChange({ industrySpecifics: readValue(e) })}
        />
        {errors.industrySpecifics && (
          <span className="ai-form-step__error" role="alert">
            {errors.industrySpecifics}
          </span>
        )}
      </label>

      <label className="ai-form-step__field">
        <span className="ai-form-step__label">Program Description</span>
        <Textarea
          rows={4}
          maxLength={CRITERIA_FREE_TEXT_MAX}
          value={criteria.programDescription}
          onInputChange={(e) => onChange({ programDescription: readValue(e) })}
          placeholder="Say a few words that describe your program and its goals."
        />
        {errors.programDescription && (
          <span className="ai-form-step__error" role="alert">
            {errors.programDescription}
          </span>
        )}
      </label>

      <div className="ai-form-step__field">
        <span className="ai-form-step__label">Match Flexibility</span>
        <ButtonGroup
          buttons={segmentedButtons(
            MATCH_FLEXIBILITY_OPTIONS,
            "matchFlexibility"
          )}
          selected={criteria.matchFlexibility?.id}
        />
      </div>
    </div>
  );
};
